const config = require('../config')
import api from '../api/index-client'
import store from "../store";

export function getAuthCode(redirect_uri) {
  return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.weixinAppId + '&redirect_uri='+ encodeURIComponent( config.winxinOpenUrl + redirect_uri) +'&response_type=code&scope=snsapi_base#wechat_redirect';
}

